import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const FacebookSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={23}
    fill="none"
    {...props}
  >
    <rect
      width={21.802}
      height={21.802}
      x={0.137}
      y={0.59}
      fill="#fff"
      rx={10.901}
    />
    <path
      fill="#0C1518"
      d="M15.943 11.491a4.92 4.92 0 0 0-4.905-4.905 4.92 4.92 0 0 0-4.906 4.905 4.888 4.888 0 0 0 4.109 4.844v-3.433H9.014v-1.41h1.227v-1.105c0-1.226.736-1.9 1.84-1.9.551 0 1.103.122 1.103.122v1.227h-.613c-.613 0-.797.367-.797.735v.92h1.349l-.246 1.41h-1.165v3.496a4.949 4.949 0 0 0 4.231-4.906Z"
    />
  </svg>
)
export default FacebookSVG
